import React from 'react';
import colors from '../../../colors';
import { Seat } from './styles';

export default ({ name, party, lastName }) => {
	const fullName = `${name} ${lastName}\n${party.shortcut}`;

	return (
		<Seat
			style={{ backgroundColor: colors[party.id] || colors.default }}
			title={fullName}
			data-vid={party.vid}
		></Seat>
	);
};
